'use client'

import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Badge } from '@/ui/badge/Badge'
import { Icon } from '@/ui/icons/icon/Icon'
import { InfoTooltip } from '@/ui/tooltips/info-tooltip/InfoTooltip.client'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { CartItemPaymentWarningDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query CartItemPaymentWarning {
    currentUser {
      id
      checkout {
        payment {
          availableMethods {
            card {
              status
            }
          }
        }
      }
    }
  }
`)

export function CartItemPaymentWarning({ isDisabled }: { isDisabled?: boolean }) {
  const { t } = useTranslation(['cartItemPaymentWarning'])
  const { data } = useQuery(CartItemPaymentWarningDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    initialFetchPolicy: 'cache-first',
  })

  if (!data?.currentUser?.checkout?.payment?.availableMethods?.card?.status) {
    return null
  }

  return (
    <InfoTooltip isDisabled={isDisabled} tooltipText={<>{t('cartItemPaymentWarning:tooltip')}</>}>
      <Badge tint="warning" size="sm" icon={<Icon.Info size="sm" />}>
        {t('cartItemPaymentWarning:tag')}
      </Badge>
    </InfoTooltip>
  )
}
